/**
 * Snippet to initialize the Zendesk instance
 */
const initialize = (appId: string, timeout = 0, onShow: () => void, onHide: () => void) => {
  // If the window width is smaller than or equal to 767 or Zendesk is already initialized, return
  if (window.innerWidth <= 767 || !!window.zE) {
    return;
  }

  // Injects the Zendesk script into the DOM
  var zeScript = document.createElement('script');
  zeScript.id = 'ze-snippet';
  zeScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${appId}`;
  document.body.appendChild(zeScript);

  // Generates a new JWT token for the user
  async function generateNewJwtToken() {
    try {
      const response = await fetch('/users/zendesk_jwt_authentication');
      const data = await response.json();
      setZendeskChatCookie(data.jwt, 1); // Set the JWT cookie with 1-hour expiration
      return data.jwt;
    } catch (error) {
      console.error('Error fetching JWT:', error);
      return null;
    }
  }

  // Logs in the user to Zendesk using JWT token taken from infograph backend
  async function loginUserToZendesk() {
    const jwt = await generateNewJwtToken();
    if (jwt && window.zE) {
      window.zE('messenger', 'loginUser', function (callback: any) {
        callback(jwt);
      });
    }
  }

  // Sets up event listeners and logs in the user once the Zendesk script is loaded
  function onZendeskScriptLoaded() {
    if (!window.zE) {
      return;
    }
    window.zE('messenger:on', 'open', onShow);
    window.zE('messenger:on', 'close', onHide);

    loginUserToZendesk();
  }

  // Add event listener for when the Zendesk script is loaded
  zeScript.addEventListener('load', onZendeskScriptLoaded);
};

export default initialize;

// Sets the JWT cookie for Zendesk chat with a given value and expiration time in hours
const setZendeskChatCookie = (value: string, expires: number) => {
  const cookieName = 'vg_zendesk_jwt';
  const domainParts = window.location.hostname.split('.');
  const zendeskChatCookieDomain = '.' + domainParts.slice(-2).join('.');
  const date = new Date();
  date.setTime(date.getTime() + expires * 60 * 60 * 1000);
  const expiresString = 'expires=' + date.toUTCString();
  document.cookie = cookieName + '=' + value + ';' + expiresString + ';path=/;domain=' + zendeskChatCookieDomain;
};
